import React from "react";

class Home extends React.Component {
  render() {
    return (
      <div className="col-md-15 col-md-offset-2" id="text">
        <div className="col-sm-10">
          <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" />
          <h2>Welcome to the Console</h2>
          <p>Please select the options from the header panel to reach your destination. Information on them was provided below.</p>
          <hr />
          <h3>Application management</h3>
          <p>To deploy the application files to a vendor by selecting App name, Version, Vendor. Data grid will be displayed on the top to know the current deployed versions to a vendor, latest versions information & version history hyperlink available for every App.</p>
          <hr />
          <h3>Vendor Management</h3>
          <p>To Add, remove, list the vendors. Also network share path can be edited for a vendor and it can dynamically update the path for all the apps deployed to that vendor. </p>
          <hr />
          <h3>Support</h3>
          <p>To navigate to hcl-support-team slack channel for any help.</p>
        </div>
      </div>
    );
  }
}
export default Home;



// WEBPACK FOOTER //
// ./src/Home.js